// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IReceiptPatchDto
 */
export interface IReceiptPatchDto {
    /**
     * 
     * @type {string}
     * @memberof IReceiptPatchDto
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IReceiptPatchDto
     */
    active?: boolean;
}

/**
 * Check if a given object implements the IReceiptPatchDto interface.
 */
export function instanceOfIReceiptPatchDto(value: object): value is IReceiptPatchDto {
    return true;
}

export function IReceiptPatchDtoFromJSON(json: any): IReceiptPatchDto {
    return IReceiptPatchDtoFromJSONTyped(json, false);
}

export function IReceiptPatchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReceiptPatchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function IReceiptPatchDtoToJSON(json: any): IReceiptPatchDto {
    return IReceiptPatchDtoToJSONTyped(json, false);
}

export function IReceiptPatchDtoToJSONTyped(value?: IReceiptPatchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'active': value['active'],
    };
}

